<template>
	<section
		class="dialog"
		v-if="dialogVisible"
		v-htmlclass="customHtmlClasses"
	>
		<div
			class="dialog__backdrop"
		/>
		<div
			ref="wrapper"
			class="dialog__wrapper"
			@click="closeFromWrapper"
		>
			<div
				class="dialog__window"
			>
				<!-- <button
					class="dialog__close"
					@click.prevent="close"
				>
					<SVGClose/>
				</button> -->
				<div class="dialog__content">
					<h2
						class="dialog__title"
						v-html="dialogTitle"
					/>
					<div
						class="dialog__message"
						v-html="dialogMessage"
					/>
					<div class="dialog__buttons">
						<Button
							type="button"
							level="secondary"
							:text="dialogCancel"
							:variants="[
								'small'
							]"
							v-if="dialogCancel"
							@click.prevent="onCancel"
						/>
						<Button
							type="button"
							level="primary"
							:text="dialogConfirm"
							:variants="[
								'small'
							]"
							v-if="dialogConfirm"
							@click.prevent="onConfirm"
						/>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import {mapGetters} from 'vuex';
import htmlComponent from 'htmlcomponent'
import {storeScrollPos, restoreScrollPos} from '@/utils/scrollpos';
import GenericMixin from '@/mixins/GenericVueMixin';
import Button from '@/components/Button';

export default {
	mixins: [
		GenericMixin,
	],
	components: {
		Button,
	},
	props: {
		htmlClasses: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
		};
	},
	computed: {
		...mapGetters('dialog', [
			'dialogTitle',
			'dialogMessage',
			'dialogConfirm',
			'dialogCancel',
			'dialogVisible'
		]),
		customHtmlClasses() {
			return this.htmlClasses.reduce((acc, cls) => {
				return {...acc, [cls]: this.visible};
			}, {});
		}
	},
	methods: {
		onCancel() {
			this.$store.dispatch('dialog/cancelDialog');
		},
		onConfirm() {
			this.$store.dispatch('dialog/confirmDialog');
		},
		closeFromWrapper(e) {
			// if (e.target == this.$refs.wrapper) {
			// 	this.close();
			// }
		},
	}
}
</script>

<style>

</style>